<template>
  <div
    :class="{ 'bcc-select': true, disabled: disabled }"
    @click.stop="toggleMenu"
    v-clickoutside="handleClose"
    :style="`width: ${width};`"
  >
    <div class="bcc-select-input-wrap">
      <input
        class="bcc-select-input-inner"
        ref="reference"
        v-model="selectedLabel"
        type="text"
        readonly
        :placeholder="placeholder"
        :validate-event="false"
        :class="{ 'is-focus': showMenu }"
      />
      <bcc-icon v-if="showMenu" type="ic_pull" />
      <bcc-icon v-else type="ic_drop-down" />
    </div>

    <transition name="bcc-select-zoom-in-top">
      <div class="bcc-select-list-wrap" v-show="showMenu">
        <ul class="bcc-select-option-list">
          <slot></slot>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
import Emitter from '../../utils/emitter'
import Clickoutside from '../../utils/clickoutside'
import BccIcon from '../icon'

export default {
  name: 'BccSelect',
  componentName: 'BccSelect',
  mixins: [Emitter],
  components: {
    BccIcon
  },
  data () {
    return {
      selectedLabel: '',
      showMenu: false,
      options: [],
      focused: false
    }
  },
  provide () {
    return {
      select: this
    }
  },
  props: {
    value: {
      default: null
    },
    disabled: Boolean,
    readonly: {
      type: Boolean,
      default () {
        return true
      }
    },
    placeholder: {
      type: String,
      default () {
        return '请选择内容'
      }
    },
    width: {
      type: String,
      default () {
        return '150px'
      }
    }
  },
  computed: {
    selectDisabled () {
      return this.disabled
    }
  },
  directives: { Clickoutside },
  watch: {
    value (val) {
      this.updateLabel()
      this.$emit('on-change', val)
    }
  },
  mounted () {
    this.$on('handleOptionClick', this.handleOptionSelect)
    this.$on('updateLabel', this.updateLabel)
    this.updateLabel()
  },
  methods: {
    updateLabel () {
      let item = this.options.find(item => item.value === this.value)
      if (item) {
        this.selectedLabel = item.displayLabel
      } else {
        this.selectedLabel = ''
      }
    },
    toggleMenu () {
      if (this.selectDisabled) return
      this.showMenu = !this.showMenu
    },
    openMenu () {
      if (this.selectDisabled) return
      this.showMenu = true
    },
    handleClose () {
      this.showMenu = false
    },
    handleOptionSelect (option) {
      this.selectedLabel = option.displayLabel
      this.$emit('input', option.value)
      this.handleClose()
    }
  }
}
</script>
